import { render } from "./PersonalObjects.vue?vue&type=template&id=73f585c4&scoped=true"
import script from "./PersonalObjects.vue?vue&type=script&lang=js"
export * from "./PersonalObjects.vue?vue&type=script&lang=js"

import "./PersonalObjects.vue?vue&type=style&index=0&id=73f585c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f585c4"]])

export default __exports__